import React, { useEffect, useState } from 'react'
import PhotoWall from './PhotoWall';
import './photoPage.css';
import HomeBtn from '../../buttons/HomeBtn';

function PhotoPage() {
  const [photoData, setPhotoData] = useState({ count: 0, images: [] });
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  useEffect(() => {
    // const imagesApiUrl = process.env.REACT_APP_API_URL;
     
    const imagesApiUrl = process.env.REACT_APP_API_URL;

    const fetchPhotos = async () => {
      try {
        const response = await fetch(imagesApiUrl);

        // console.log('Response status:', response.status);
        // console.log('Response ok:', response.ok);

        // const text = await response.text();
        // console.log('Raw:', text)
        // console.log('response len:', text.length);

        if (!response.ok) {
          throw new Error(`FAILED TO FETCH IMAGES! ERROR: ${response.status}`);
        }

        const data = await response.json();
        setPhotoData(data);
      } catch (err) {
        setError(err.message);
        console.error('ERROR FETCHING PHOTOS:', err);
      } finally {
        setLoading(false);
      }
    };

    fetchPhotos();
  }, []);

  return (
    <div className='photo-app'>
      <HomeBtn />
      <header className='photo-header'>
        <h1>PHOTOGRAPHY</h1>
      </header>
      <main>
        {loading && <div className='loading-msg'>Loading photos...</div>}
        {error && <div className='error-msg'>Error: {error}</div>}
        {!loading && !error && <PhotoWall photos={photoData.images} />}
      </main>
    </div>
  );
}

export default PhotoPage;